import { i18n } from '@/i18n'
import parent from '@/store/interfaces/tableViewGeneric'

const getTranslateMasterFilters = function () {
  return {
    estado: { label: i18n.t('app.status'), value: '' },
    estadoExtra: { label: i18n.t('app.status'), value: '' },
    fechaFacturaDesde: { label: i18n.t('invoices.filters.invoice_date_from'), value: '', type: 'date' },
    fechaFacturaHasta: { label: i18n.t('invoices.filters.invoice_date_to'), value: '', type: 'date' },
    tipoInvoiceClass: { label: i18n.t('invoices.tipo_factura'), value: '' },
    importeDesde: { label: i18n.t('invoices.filters.invoice_importe_min'), value: '', type: 'number' },
    importeHasta: { label: i18n.t('invoices.filters.invoice_importe_max'), value: '', type: 'number' },
    numFactura: { label: i18n.t('invoices.num_factura'), value: '' },
    SerieFactura: { label: i18n.t('invoices.serie_factura'), value: '' },
    cifEmisor: { label: i18n.t('invoices.cif_emisor'), value: '' },
    NombreCIFEmisor: { label: i18n.t('invoices.emisor'), value: '' },
    cifReceptor: { label: i18n.t('invoices.cif_receptor'), value: '' },
    NombreCIFReceptor: { label: i18n.t('invoices.receptor'), value: '' },
    empresa: { label: i18n.t('clients.entity_name'), value: '' },
    importe: { label: i18n.t('invoices.importe'), value: '', type: 'number' },
    notas: { label: i18n.t('invoices.notas'), value: '' },
    csv: { label: i18n.t('invoices.csv'), value: '' },
    ultimoError: { label: i18n.t('invoices.error_temporal'), value: '' },
    pge: { label: i18n.t('app.forma_envio'), value: '' },
    metadatos: { label: i18n.tc('invoices.metadatos.metadato', 2), value: '' },
    fechaAltaDesde: { label: i18n.t('app.filters.fecha_alta_from'), value: '', type: 'date' },
    fechaAltaHasta: { label: i18n.t('app.filters.fecha_alta_to'), value: '', type: 'date' },
    fechaPagoDesde: { label: i18n.t('invoices.filters.fecha_pago_from'), value: '', type: 'date' },
    fechaPagoHasta: { label: i18n.t('invoices.filters.fecha_pago_to'), value: '', type: 'date' },
    fechaRechazoDesde: { label: i18n.t('invoices.filters.fecha_rechazo_from'), value: '', type: 'date' },
    fechaRechazoHasta: { label: i18n.t('invoices.filters.fecha_rechazo_to'), value: '', type: 'date' },
    OrigenFactura: { label: i18n.t('invoices.origen_factura'), value: '' },
  }
}
const getColumns = function getColumns () {
  return [
    { field: 'NumFactura', title: i18n.t('invoices.num_factura'), columnMenu: 'myTemplate', locked: false, width: '200px' },
    { field: 'SerieFactura', title: i18n.t('invoices.serie_factura'), columnMenu: 'myTemplate', locked: false, width: '200px' },
    {
      field: 'NombreCliente',
      title: i18n.t('clients.entity_name'),
      columnMenu: 'myTemplate',
      locked: false,
      width: '180px',
      only: {
        roles: [8, 3],
      },
    },
    {
      field: 'Distribuidor',
      title: i18n.t('distributors.entity_name'),
      columnMenu: 'myTemplate',
      hidden: true,
      locked: false,
      width: '180px',
      only: {
        roles: [3],
      },
    },
    { field: 'NombreCIFReceptor', title: i18n.t('invoices.receptor'), columnMenu: 'myTemplate', locked: false, width: '220px', minWidth: 200 },
    { field: 'CIFReceptor', title: i18n.t('invoices.cif_receptor'), columnMenu: 'myTemplate', locked: false, width: '220px', minWidth: 200 },
    { field: 'URLVerifactu', title: i18n.t('invoices.qr_verifactu'), columnMenu: 'myTemplate', locked: false, width: '220px', minWidth: 200 },
    { field: 'CSVVerifactu', title: i18n.t('invoices.csv_verifactu'), columnMenu: 'myTemplate', locked: false, width: '220px', minWidth: 200 },
    // { field: 'FechaEntregaTicketbai', title: i18n.t('invoices.fecha_entrega_ticketbai'), cell: 'fechaTemplate', type: 'date', filter: 'date', format: 'numeric_datetime', columnMenu: 'myTemplate', locked: false, width: '220px', extraparams: { separators: { date: '-', datetime: ' ' } } },
    { field: 'IdTBAI', title: i18n.t('invoices.id_ticketbai'), columnMenu: 'myTemplate', locked: false, width: '220px', minWidth: 200 },
    // { field: 'EstadoTicketBAI', title: i18n.t('invoices.estado_ticketbai'), columnMenu: 'myTemplate', locked: false, width: '220px', minWidth: 200 },
    { field: 'Importe', title: i18n.t('invoices.importe'), columnMenu: 'myTemplate', format: 'currency', cell: 'numberTemplate', locked: false, width: '120px' },
    // { field: 'Tipo', title: i18n.t('invoices.tipo_factura'), columnMenu: 'myTemplate', locked: false, width: '180px' },
    { field: 'FechaFactura', title: i18n.t('app.date'), type: 'date', filter: 'date', format: 'numeric_date', columnMenu: 'myTemplate', cell: 'fechaTemplate', extraparams: { separators: { date: '-' } }, locked: false, width: '180px' },
    // { field: 'Concepto', title: i18n.t('invoices.concepto'), columnMenu: 'myTemplate', locked: false, width: '220px', minWidth: 200 },
    { field: 'NombreCIFEmisor', title: i18n.t('invoices.emisor'), columnMenu: 'myTemplate', locked: false, width: '220px', minWidth: 200 },
    { field: 'CIFEmisor', title: i18n.t('invoices.cif_emisor'), columnMenu: 'myTemplate', locked: false, width: '220px', minWidth: 200 },
    { field: 'idEstado', title: i18n.t('app.status'), format: 'TIPOS_ESTADO', cell: 'enumTemplate', columnMenu: 'myTemplate', locked: false, width: '220px', minWidth: 200, },
    { field: 'Pge', title: i18n.t('app.forma_envio'), format: 'TIPOS_PGE', cell: 'enumTemplate', columnMenu: 'myTemplate', locked: false, width: '220px', minWidth: 200 },
    { field: 'CorrectionMethod', title: i18n.t('invoices.tipo_factura'), format: 'TIPOS_INVOICE_CLASS', cell: 'enumTemplate', columnMenu: 'myTemplate', locked: false, width: '220px', minWidth: 200, hidden: true, sortable: false, groupable: false },
    { field: 'Grupos', width: '375px', title: i18n.t('groups.header'), columnMenu: 'myTemplate', locked: false, cell: 'groupsTemplate', type: 'boolean', sortable: false, groupable: false },
    { field: 'Csv', title: i18n.t('invoices.csv'), columnMenu: 'myTemplate', locked: false, width: '220px', hidden: true },
    { field: 'FechaPago', title: i18n.t('invoices.fecha_pago'), type: 'date', filter: 'date', format: 'numeric_date', columnMenu: 'myTemplate', cell: 'fechaTemplate', extraparams: { separators: { date: '-' } }, locked: false, width: '180px', },
    { field: 'FechaRechazo', title: i18n.t('invoices.fecha_rechazo'), type: 'date', filter: 'date', format: 'numeric_date', columnMenu: 'myTemplate', cell: 'fechaTemplate', extraparams: { separators: { date: '-' } }, locked: false, width: '180px', },
    { field: 'MotivoRechazo', title: i18n.t('configurations.reject_msgs'), columnMenu: 'myTemplate', locked: false, width: '220px', minWidth: 200, hidden: false },
    { field: 'UltimoError', title: i18n.t('invoices.error_temporal'), columnMenu: 'myTemplate', locked: false, width: '220px', minWidth: 200, hidden: true },
    { field: 'OrigenFactura', title: i18n.t('invoices.origen_factura'), format: 'TIPOS_ORIGEN_FACTURA', cell: 'enumTemplate', columnMenu: 'myTemplate', locked: false, width: '220px', minWidth: 200, hidden: true, only: { roles: [3] } },
    { field: 'idFacturae', title: i18n.t('invoices.idFacturae'), hidden: true, columnMenu: 'myTemplate', locked: false, width: '120px' },
    { field: 'idInvoice', title: i18n.t('invoices.idInvoice'), hidden: true, columnMenu: 'myTemplate', locked: false, width: '120px' },
    { 
      field: 'idCliente', 
      title: i18n.t('clients.id_client'), 
      hidden: true, 
      columnMenu: 'myTemplate', 
      width: '150px', 
      locked: false,
      only: {
        roles: [8, 3],
      },
    },
  ] 
}
const mystore = parent({ selectable: true, navigate: true, namespaced: true, getTranslateColumns: getColumns, getTranslateMasterFilters })

export default mystore
